import React from 'react';
import { useQuery } from 'react-query';
import { Get } from '../../../../utils/httpProvider';
import { ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

/**
 * Component hiển thị thông tin Cán bộ (Họ tên, CCCD)
 * Thực hiện lấy dữ liệu từ Backend Auth (Port 5003) ngay tại Frontend.
 * Tận dụng React Query để cache dữ liệu, tránh gọi API lặp lại cho cùng 1 User.
 */
const UserInfoCell = ({ userId, firstName, middleName, lastName, userName, hideUsername }) => {
    const { data: accountInfo, isLoading: loadingAccount } = useQuery(
        ['accountInfo', userId],
        () => Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, userId),
        {
            enabled: !!userId && !firstName,
            staleTime: 600000,
            cacheTime: 900000,
        }
    );

    if (!userId) return <span className="text-muted">N/A</span>;
    
    if (loadingAccount && !firstName) {
        return (
            <div className="d-flex align-items-center">
                <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                <small className="text-muted" style={{ fontSize: '0.8rem' }}>Đang tải...</small>
            </div>
        );
    }

    // AccountAuthInfo/GetItem trả về fields trực tiếp, Account/GetItem trả về nested trong accountAuthInfo
    const authInfo = accountInfo?.accountAuthInfo || accountInfo?.AccountAuthInfo || accountInfo;
    const fullName = firstName ? [lastName, middleName, firstName].filter(Boolean).join(' ') : ([
        authInfo?.lastName || authInfo?.LastName,
        authInfo?.middleName || authInfo?.MiddleName,
        authInfo?.firstName || authInfo?.FirstName
    ].filter(Boolean).join(' ') || 'Chưa cập nhật');

    const uName = userName || accountInfo?.account?.username || accountInfo?.account?.Username || accountInfo?.username || accountInfo?.Username || accountInfo?.identityCardNumber || accountInfo?.IdentityCardNumber || accountInfo?.accountAuthInfo?.identityCardNumber || accountInfo?.AccountAuthInfo?.IdentityCardNumber;

    return (
        <div className="d-flex flex-column">
            <span className="font-weight-bold text-dark" style={{ fontSize: '0.9rem' }}>{fullName}</span>
            {!hideUsername && uName && <small className="text-muted" style={{ fontSize: '0.75rem' }}>{uName}</small>}
        </div>
    );
};

export default UserInfoCell;
